/**
 * Created by lihanying on 2017/7/17.
 */
import React from 'react'
import { Table, Button, Input, message } from 'antd'
import ModalDetail from './modalDetail'
import ModalAdd from './modalAdd'
import ModalSpeed from './modalSpeed'
import ModalType from './modalType'
import ModalOut from './modalOut'
import './style.css'
import { changeToDecimal } from '../../../util'

const Search = Input.Search

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      modalAdd: false,
      modalSpeed: false,
      modalType: false,
      modalOut: false,
      selectedRowKeys: [],
      total_c: 0,
      page: 1,
      loading: false,
    }
  }

  componentDidMount() {
    this.props.fetchQiniuToken() //获取token值
    this.props.fetchCommodityType()
    this.props.fetchCommodityAddTotal() //区域
  }

  onShowVisible = (record) => {
    this.setState({
      visible: true,
      record: record,
      loading: true,
    })
    this.props.fetchGetProcurement(record.id).then((res) => {
      this.setState({ loading: false })
    })
    this.props.fetchCommodityTotal(record.id) //区域
  }

  //商品分页
  handlePage = (page) => {
    const { clubCommodity } = this.props
    this.setState({ page: page }, () =>
      this.props.fetchClubCommodity({
        p: page,
        search: clubCommodity.parameter.searchInput,
      })
    )
  }

  //商品接口参数
  params = () => {
    const { page } = this.state
    const { clubCommodity } = this.props
    const obj = {
      p: page,
      search: clubCommodity.parameter.searchInput,
    }
    return obj
  }

  handleOk = () => {
    //修改商品
    const { record, total_c } = this.state
    const { commodityTotal, imageUrl } = this.props
    const obj = this.params()
    const al_price = sessionStorage.getItem('al_price'),
      re_price = sessionStorage.getItem('re_price')
    let total_id = []
    commodityTotal.firmList &&
      commodityTotal.firmList.map((item) => {
        if (+item.access === 1) {
          total_id.push(item.id)
        }
      })
    let imgUrl
    if (imageUrl.url) {
      imgUrl = imageUrl.url
    } else {
      imgUrl = record.commodity_pic_url
    }
    if (
      sessionStorage.getItem('commodity_name') ||
      sessionStorage.getItem('commodity_price') ||
      sessionStorage.getItem('unit') ||
      sessionStorage.getItem('type_id') ||
      sessionStorage.getItem('order_num') ||
      sessionStorage.getItem('off_shelve') ||
      total_c !== 0 ||
      imageUrl.url ||
      sessionStorage.getItem('al_price') ||
      sessionStorage.getItem('re_price') ||
      al_price > 0 ||
      (re_price !== '' && al_price > 0) ||
      (re_price !== '' && re_price !== null && record.al_price) ||
      (al_price === '' && re_price === '' && record.al_price) ||
      (al_price === '' && re_price === '' && record.re_price)
    ) {
      let al_pri = al_price || record.al_price,
        re_pri = re_price || record.re_price
      if (al_price === '' && re_price === '') {
        //都为空时取空
        al_pri = ''
        re_pri = ''
      }
      const data = {
        id: record.id,
        name: sessionStorage.getItem('commodity_name') || record.commodity_name,
        price:
          sessionStorage.getItem('commodity_price') || record.commodity_price,
        unit: sessionStorage.getItem('unit') || record.unit,
        type_id: sessionStorage.getItem('type_id') || record.type_id,
        pic: imgUrl,
        ordernum: sessionStorage.getItem('order_num') || record.ordernum,
        off_shelve: sessionStorage.getItem('off_shelve') || record.off_shelve,
        non_standard: record.non_standard,
        firm_ids: total_c === 0 ? total_id : total_c,
        al_price: al_pri,
        re_price: re_pri,
      }
      this.props.fetchSetCommodity('EditCommodity', data, obj)
      this.setState({ visible: false, total_c: 0 }, () => {
        this.clearSession()
        this.props.getImageUrl({})
      })
    } else {
      message.info(re_price ? '请先输入钻石数量' : '请先输入要修改的信息')
    }
  }

  handleCancel = () => {
    this.setState({ visible: false, total_c: 0 }, () => {
      this.clearSession()
      this.props.getImageUrl({})
    })
  }

  handleEditCheckbox = (value) => {
    this.setState({ total_c: value })
  }

  clearSession = () => {
    sessionStorage.removeItem('commodity_name')
    sessionStorage.removeItem('commodity_price')
    sessionStorage.removeItem('unit')
    sessionStorage.removeItem('type_id')
    sessionStorage.removeItem('order_num')
    sessionStorage.removeItem('off_shelve')
    sessionStorage.removeItem('qty_outcome')
    sessionStorage.removeItem('re_price')
    sessionStorage.removeItem('al_price')
  }

  /****************添加商品****************/

  handleOkSubmit = (item) => {
    const obj = this.params()
    if (item.materials === '1') {
      if (item.type_id && item.name && item.unit) {
        this.props.fetchSettingCommodity('AddCommodity', item, obj, () => {
          this.setState({ modalAdd: false })
        })
      } else {
        message.info('您还有内容未填写')
      }
    } else {
      if (
        item.type_id &&
        item.name &&
        item.price &&
        item.unit &&
        item.warning
      ) {
        if (!item.re_price || item.al_price) {
          this.props.fetchSettingCommodity('AddCommodity', item, obj, () => {
            this.setState({ modalAdd: false })
          })
        } else {
          message.info('您必须输入钻石数量')
        }
      } else {
        message.info('您还有内容未填写')
      }
    }
  }

  handleCancelModal = () => {
    this.setState({ modalAdd: false }, () => {
      this.props.getImageUrl({})
    })
  }

  handleOkSpeed = (item) => {
    const obj = this.params()
    if (item.qty_income && item.type == '1') {
      //入库
      this.props.fetchSettingCommodity(
        'Procurement',
        {
          commodity_id: item.commodity_id,
          cost_income: item.cost_income,
          qty_income: item.qty_income,
        },
        obj
      )
      this.setState({ modalSpeed: false })
    } else if (item.qty_outcome && item.type == '2') {
      //退货
      this.props.fetchSetCommodity(
        'OutputCommodity',
        {
          commodity_id: item.commodity_id,
          qty_outcome: item.qty_outcome,
        },
        obj
      )
      this.setState({ modalSpeed: false })
    } else {
      message.info('请输入入库/出库数量')
    }
  }

  handleCancelSpeed = () => {
    this.setState({ modalSpeed: false, modalType: false }, () =>
      this.props.fetchClubCommodity(this.params())
    )
  }
  handleCancelOut = () => {
    this.setState({ modalOut: false }, () =>
      this.props.fetchClubCommodity(this.params())
    )
  }

  render() {
    const {
      clubCommodity,
      commodityType,
      qiniuToken,
      imageUrl,
      inStorage,
      commodityTotal,
      clubCommodityOut,
    } = this.props
    const typename =
      commodityType &&
      commodityType.map((item) => {
        return { text: item.name, value: item.name }
      })
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '商品名称',
        dataIndex: 'commodity_name',
        key: 'commodity_name',
      },
      {
        title: '类型',
        dataIndex: 'typename',
        key: 'typename',
        filters: typename,
        filterMultiple: false,
        onFilter: (value, record) => record.typename.indexOf(value) === 0,
      },
      {
        title: '零售价',
        dataIndex: 'commodity_price',
        key: 'commodity_price',
        sorter: (a, b) => a.commodity_price - b.commodity_price,
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '库存',
        dataIndex: 'balance',
        key: 'balance',
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div style={{ color: '#108EE9', cursor: 'default' }}>
              <span
                onClick={() => {
                  this.setState({ modalSpeed: true, record: record })
                }}
              >
                快速入库 |{' '}
              </span>
              <span
                onClick={() => this.onShowVisible(record)}
                style={{ color: '#2BAE29' }}
              >
                {' '}
                详情
              </span>
            </div>
          )
        },
      },
    ]

    return (
      <div>
        <h3>商品列表</h3>
        <Search
          placeholder="请输入关键字查询"
          style={{ width: 200, marginBottom: '1rem' }}
          onSearch={(value) =>
            this.props.fetchClubCommodity({ search: value, p: 1 })
          }
        />
        <Button
          type="primary"
          className="commodity_btn"
          onClick={() => this.setState({ modalAdd: true })}
        >
          添加 新商品
        </Button>
        <Button
          type="primary"
          className="commodity_btn"
          onClick={() => this.setState({ modalType: true })}
        >
          分类查询
        </Button>
        <Button
          type="primary"
          className="commodity_btn"
          onClick={() =>
            this.setState({ modalOut: true }, () =>
              this.props.fetchClubCommodity({
                p: 1,
                out: 1,
              })
            )
          }
        >
          已下架商品
        </Button>
        <Table
          rowKey="id"
          bordered
          columns={columns}
          dataSource={clubCommodity.list}
          size="middle"
          pagination={{
            pageSize: 5,
            total: clubCommodity.count,
            showSizeChanger: false,
          }}
          onChange={(page) => this.handlePage(page.current)}
        />

        {this.state.visible && (
          <ModalDetail
            {...this.state}
            commodityType={commodityType}
            qiniuToken={qiniuToken}
            imageUrl={imageUrl}
            inStorage={inStorage}
            commodityTotal={commodityTotal}
            handleOk={this.handleOk}
            handleCancel={this.handleCancel}
            fetchQiniu={this.props.fetchQiniu}
            getImageUrl={this.props.getImageUrl}
            handleEditCheckbox={this.handleEditCheckbox}
            fetchRemoveFreeze={this.props.fetchRemoveFreeze}
            loading={this.state.loading}
          />
        )}
        {this.state.modalAdd && (
          <ModalAdd
            {...this.state}
            commodityType={commodityType}
            qiniuToken={qiniuToken}
            imageUrl={imageUrl}
            commodityTotal={commodityTotal}
            handleOk={this.handleOkSubmit}
            handleCancel={this.handleCancelModal}
            fetchQiniu={this.props.fetchQiniu}
            getImageUrl={this.props.getImageUrl}
          />
        )}

        {this.state.modalSpeed && (
          <ModalSpeed
            {...this.state}
            inStorage={inStorage.info}
            handleOk={this.handleOkSpeed}
            handleCancel={this.handleCancelSpeed}
          />
        )}
        {this.state.modalType && (
          <ModalType {...this.state} handleCancel={this.handleCancelSpeed} />
        )}
        {this.state.modalOut && (
          <ModalOut
            {...this.state}
            clubCommodityOut={clubCommodityOut}
            handleCancel={this.handleCancelOut}
            fetchClubCommodity={this.props.fetchClubCommodity}
            fetchSetCommodity={this.props.fetchSetCommodity}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/component/commodityList.js